import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { TicketEvent } from '../../types';

export default function Tickets() {
  const [events, setEvents] = useState<TicketEvent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      const now = new Date().toISOString();
      const { data } = await supabase
        .from('ticket_events')
        .select('*')
        .gte('event_date', now)
        .order('event_date')
        .limit(20);
      setEvents(data || []);
      setLoading(false);
    };
    fetchEvents();
  }, []);

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', { 
      weekday: 'long', 
      day: 'numeric', 
      month: 'long',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatPrice = (cents: number, currency: string) => {
    return new Intl.NumberFormat('es-ES', { 
      style: 'currency', 
      currency: currency 
    }).format(cents / 100);
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Eventos con Boletería</h1>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
        </div>
      ) : events.length === 0 ? (
        <div className="card text-center py-8">
          <p className="text-[#8E8E93]">No hay eventos con boletos disponibles</p>
        </div>
      ) : (
        <div className="space-y-3">
          {events.map((event) => (
            <Link
              key={event.id}
              to={`/tickets/${event.id}`}
              className="card block "
            >
              {event.image_url && (
                <img src={event.image_url} alt={event.title} className="w-full h-40 object-cover rounded-lg mb-3" />
              )}
              <h3 className="font-semibold text-white text-lg">{event.title}</h3>
              <p className="text-sm text-[#8E8E93] mt-1">📅 {formatDate(event.event_date)}</p>
              {event.location && <p className="text-sm text-[#8E8E93]">📍 {event.location}</p>}
              
              <div className="flex items-center justify-between mt-3">
                <span className="text-lg font-bold text-primary">
                  {formatPrice(event.price_cents, event.currency)}
                </span>
                <span className="text-sm text-[#8E8E93]">
                  {event.capacity - event.sold_count} disponibles
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
